import { useMemo } from "react";
import { useRouter } from "next/router";

/**
 * Custom hook to retrieve the list ID based on the current route slug.
 * Falls back to "related_products" if no valid slug is found.
 *
 * @returns {string} The list ID extracted from the last slug in the route.
 */
export function useListId(): string {
    const { query } = useRouter();

    return useMemo(() => {
        const slugs = query.slugs as string[] | undefined;
        if (!slugs?.length) {
            return "products";
        }
        return slugs[slugs.length - 1] || "products";
    }, [query.slugs]);
}
